import dayjs from "dayjs";
import React from "react";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;


const DateRange = ({onDateRangeChange, startDate, endDate, minDate, maxDate,
                       dateFormat = 'YYYY-MM-DD', className=''}) => {

    const handleDateRangeChange = (dates, dateStrings) => {
        if (onDateRangeChange) {
            onDateRangeChange(dateStrings[0], dateStrings[1]);
        }
    };
    return (
        <RangePicker
            size="small"
            className={`py-3 ${className}`}
            format={dateFormat}
            defaultValue={[dayjs(startDate || minDate, dateFormat), dayjs(endDate || maxDate, dateFormat)]}
            onChange={handleDateRangeChange}
            disabledDate={current => {
                const startDay = minDate ? dayjs(minDate).subtract(1, 'day') : null;
                const endDay = maxDate ? dayjs(maxDate).add(1, 'day') : null;
                return (startDay && current <= startDay) || (endDay && current >= endDay);
            }}
            needConfirm={true}
        />
    );
};

export default DateRange;
